import type { CreateAxiosDefaults } from 'axios';

// When the dev proxy is on (default), use the relative "/api" so requests flow
// through Vite's proxy. When it's off (VITE_USE_DEV_PROXY=false), talk to the
// API directly via VITE_API_BASE_URL (requires backend CORS).
const useDevProxy = import.meta.env.VITE_USE_DEV_PROXY !== 'false';

export const apiBaseUrl = import.meta.env.DEV && useDevProxy ? '/api' : import.meta.env.VITE_API_BASE_URL;

/**
 * Shared axios config for every client in this app.
 *
 * This module deliberately creates no instances and imports neither `./index`
 * nor `./bareApi`: `./index` imports `./bareApi`, so if `bareApi` derived its
 * baseURL from `api.defaults` the two would form a module cycle. Keeping the
 * config in a third leaf module lets both consume it without one importing the
 * other.
 */
export const configApiInstance: CreateAxiosDefaults = {
  baseURL: apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
};
